/**
 * House of Places — the card's second image, loaded on first hover.
 *
 * The hover layer sits on every desktop card at opacity 0 (brand.css, 27.
 * CARD HOVER MEDIA), so an <img> with a real src downloaded in the first view
 * even though nobody saw it — 556 KB on /collections/all. card-product.liquid
 * now writes its srcset/src as data-* and this copies them across the first
 * time a pointer enters the card. On touch the layer is display:none and no
 * pointer ever "enters", so nothing is fetched there either.
 *
 * Bound on the document: facets, recommendations and the quick-add modal all
 * insert cards after load.
 */
(function () {
  var yuklu = (window.hopYuklu = window.hopYuklu || {});
  if (yuklu['hop-card-hover']) return;
  yuklu['hop-card-hover'] = true;

  document.addEventListener(
    'pointerover',
    function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      var kart = e.target.closest && e.target.closest('.card-wrapper');
      if (!kart) return;
      kart.querySelectorAll('img.hop-card-hover-media[data-srcset]').forEach(function (gorsel) {
        gorsel.srcset = gorsel.getAttribute('data-srcset');
        gorsel.src = gorsel.getAttribute('data-src');
        gorsel.removeAttribute('data-srcset');
      });
    },
    { passive: true }
  );

  /* Card photos sharp at their real size (client, 2026-10-15: "the posters
     look blurry"). card-product.liquid's sizes attribute assumes a boxed
     page ("178px" from 1200px up), but the full-width grid draws each card
     at ~410px, so the browser picked the 360w file and stretched it — on a
     1.5x screen a 178px image filled 412px. Here every card image's sizes
     is set to the width it is actually drawn at, and kept in step when the
     window or the grid changes, so the browser picks a file big enough for
     the screen (720w on that screen). */
  function olc(img) {
    var w = img.getBoundingClientRect().width;
    if (w < 50) return;
    var s = Math.ceil(w) + 'px';
    if (img.getAttribute('sizes') !== s) img.setAttribute('sizes', s);
  }
  var ro = 'ResizeObserver' in window
    ? new ResizeObserver(function (girdiler) {
        girdiler.forEach(function (g) { olc(g.target); });
      })
    : null;
  function tara(kok) {
    if (!kok.querySelectorAll) return;
    kok.querySelectorAll('.card__media img').forEach(function (img) {
      if (img.hopBoy) return;
      img.hopBoy = true;
      if (ro) ro.observe(img);
      else olc(img);
    });
  }
  function basla() {
    tara(document);
    new MutationObserver(function (kayitlar) {
      kayitlar.forEach(function (k) {
        k.addedNodes.forEach(function (n) { if (n.nodeType === 1) tara(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();
})();
